import React from "react";
import WebForm from "@/components/WebForm";
import { DataFormContexProvider } from "@/context/FormDataContext";

/**
 *
 * @returns {React.JSX.Element} Main react app
 */
export default function App(): React.JSX.Element {
  return (
    <div className="App">
      <DataFormContexProvider>
        <WebForm />
      </DataFormContexProvider>
    </div>
  );
}
